import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "blog"
}
const _hoisted_2 = {
  key: 0,
  class: "buttons"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-pencil" }, null, -1)
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "date" }
const _hoisted_6 = ["innerHTML"]

import { PropType, computed } from "vue";
import { useRouter } from "vue-router";

import { Blog } from "@/models/blog";
import { formatDateLong } from "@/filters/filters";
import { convertMarkdown } from "@/markdown/util/markdown.util";
import { useStore } from "vuex";
import { Mutations } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'Blog',
  props: {
  blog: {
    type: Object as PropType<Blog>,
    required: true
  },
  listed: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const store = useStore();
const props = __props;

const auth = computed(() => store.state.auth);

const router = useRouter();

const navigate = (id: number) => {
  router.push(`/blog/${id}`);
};
const edit = () => {
  store.commit(Mutations.SetBlog, props.blog);
  router.push(`/blog/${props.blog.id}/edit`);
};

return (_ctx: any,_cache: any) => {
  return (props.blog)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        (!__props.listed && auth.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("button", {
                type: "button",
                class: "option",
                onClick: edit
              }, [
                _hoisted_3,
                _createTextVNode(" Edit ")
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("h2", {
          textContent: _toDisplayString(props.blog.title),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (navigate(props.blog.id)))
        }, null, 8, _hoisted_4),
        _createElementVNode("i", _hoisted_5, _toDisplayString(_unref(formatDateLong)(props.blog.date)), 1),
        _createElementVNode("div", {
          innerHTML: _unref(convertMarkdown)(props.blog.text)
        }, null, 8, _hoisted_6)
      ]))
    : _createCommentVNode("", true)
}
}

})